module.exports = __webpack_public_path__ + "img/subAra5.1fb718fc.jpg";